import { render, staticRenderFns } from "./tmodify.vue?vue&type=template&id=0d7cdd70&scoped=true"
import script from "./tmodify.vue?vue&type=script&lang=js"
export * from "./tmodify.vue?vue&type=script&lang=js"
import style0 from "./tmodify.vue?vue&type=style&index=0&id=0d7cdd70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7cdd70",
  null
  
)

export default component.exports